/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiArtifactFromJSON, StreemApiArtifactToJSON, StreemApiRoomFromJSON, StreemApiRoomToJSON, } from './';
export function StreemApiEventsArtifactUpdatedFromJSON(json) {
    return StreemApiEventsArtifactUpdatedFromJSONTyped(json, false);
}
export function StreemApiEventsArtifactUpdatedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'room': !exists(json, 'room') ? undefined : StreemApiRoomFromJSON(json['room']),
        'previousArtifact': !exists(json, 'previous_artifact') ? undefined : StreemApiArtifactFromJSON(json['previous_artifact']),
        'updatedArtifact': !exists(json, 'updated_artifact') ? undefined : StreemApiArtifactFromJSON(json['updated_artifact']),
    };
}
export function StreemApiEventsArtifactUpdatedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room': StreemApiRoomToJSON(value.room),
        'previous_artifact': StreemApiArtifactToJSON(value.previousArtifact),
        'updated_artifact': StreemApiArtifactToJSON(value.updatedArtifact),
    };
}
//# sourceMappingURL=StreemApiEventsArtifactUpdated.js.map